import { Desktop } from '@/components/molecules/viewport/desktop';
import { Mobile } from '@/components/molecules/viewport/mobile';
import { TerritorialDashboardDesktop } from '@/components/organisms/territorialDashboard/desktop';
import { TerritorialDashboardMobile } from '@/components/organisms/territorialDashboard/mobile';
import { useAdvancedFiltersUrl } from '@/hooks/useAdvancedFiltersUrl';
import { useGeometry } from '@/hooks/useGeometry';
import { useTranslation } from '@/hooks/useTranslation';
import { useEffect, useRef, useState } from 'react';

export default function HomePage() {
  const [variant, setVariant] = useState<'risk' | 'opportunity'>('opportunity');

  const hasInitialRequestBeenMade = useRef(false);
  const [desktopTabValue, setDesktopTabValue] = useState(0);

  const {
    geometry,
    getGeometry,
    currentZoom,
    handleSearchFilter,
    setIsMunicipality,
  } = useGeometry();
  const { t } = useTranslation();
  const { getFiltersFromUrl } = useAdvancedFiltersUrl();

  const filters = getFiltersFromUrl();

  const handleVariant = (variant: 'risk' | 'opportunity') => {
    setVariant(variant);
  };

  useEffect(() => {
    const hasFiltersFromUrl = filters.dynamicFilters && filters.dynamicFilters.length > 0;
    const hasAdditionalMunicipalityCodes = (filters.additionalMunicipalityCodes || []).length > 0;

    const shouldMakeRequest =
      currentZoom < 3 &&
      geometry.length === 0 &&
      (hasFiltersFromUrl || hasAdditionalMunicipalityCodes) &&
      !hasInitialRequestBeenMade.current;

    if (shouldMakeRequest) {
      hasInitialRequestBeenMade.current = true;

      const searchParams = new URLSearchParams(location.search);
      const code = searchParams.get('municipality_code');

      if (hasAdditionalMunicipalityCodes) {
        setIsMunicipality(false);
        getGeometry({
          filters: {
            ...filters,
            dynamicFilters: (filters.dynamicFilters || []).filter(
              (filter) => filter.field !== 'municipality_code'
            ),
          },
          pagination: { limit: 5600 },
        });
      } else if (code) {
        setIsMunicipality(true);
        getGeometry({
          filters: {
            dynamicFilters: [
              ...(filters.dynamicFilters || []),
              { field: 'municipality_code', operator: 'eq', value: code },
            ],
          },
          pagination: { limit: 1 },
        });
      } else {
        getGeometry({ filters, pagination: { limit: 5600 } });
      }
    }
  }, [
    desktopTabValue,
    location.search,
    currentZoom,
    geometry.length,
    filters,
    getGeometry,
    setIsMunicipality,
  ]);

  useEffect(() => {
    if (filters && Object.keys(filters).length > 0) {
      handleSearchFilter(filters);
    }
  }, [desktopTabValue]);

  useEffect(() => {
    document.title = `KYT-e - ${t('page.dashboard.dashboard.title')}`;
  }, [t]);

  return (
    <>
      <Desktop>
        <TerritorialDashboardDesktop
          variant={variant}
          onChangeVariant={handleVariant}
          setTabValue={setDesktopTabValue}
          tabValue={desktopTabValue}
        />
      </Desktop>

      <Mobile>
        <TerritorialDashboardMobile variant={variant} onChangeVariant={handleVariant} />
      </Mobile>
    </>
  );
}
